export default __webpack_public_path__ + "213e6bc4ab81fb3a158c7aefb54c50a1.png";